export default __webpack_public_path__ + "1a77da89ed168a86104c61554a584a0d.svg";